import Sentry from '../api/sentry';

const { 
  REACT_APP_FIREBASE_API_KEY, 
  REACT_APP_FIREBASE_MESSAGING_SENDER_ID, 
  REACT_APP_FIREBASE_APP_ID, 
  REACT_APP_FIREBASE_MEASUREMENT_ID,
  REACT_APP_FIREBASE_AUTH_DOMAIN,
  REACT_APP_FIREBASE_DATABASE_URL,
  REACT_APP_FIREBASE_PROJECT_ID,
  REACT_APP_FIREBASE_STORAGE_BUCKET
} = process.env

let firebaseConfig = {
  apiKey: REACT_APP_FIREBASE_API_KEY,
  authDomain: REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: REACT_APP_FIREBASE_DATABASE_URL,
  projectId: REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: REACT_APP_FIREBASE_APP_ID,
  measurementId: REACT_APP_FIREBASE_MEASUREMENT_ID
};

if( 
  !REACT_APP_FIREBASE_API_KEY  ||
  !REACT_APP_FIREBASE_MESSAGING_SENDER_ID ||
  !REACT_APP_FIREBASE_APP_ID ||
  !REACT_APP_FIREBASE_MEASUREMENT_ID ||
  !REACT_APP_FIREBASE_AUTH_DOMAIN ||
  !REACT_APP_FIREBASE_DATABASE_URL ||
  !REACT_APP_FIREBASE_PROJECT_ID ||
  !REACT_APP_FIREBASE_STORAGE_BUCKET
) {
  
  Sentry.captureException(new Error("Firebase configs not found. Unable to initialize Firebase."));

  // Need to pass in some kind of data here so onboarding can run despite the configs not being set
  // Initializing app instance with null data crashes app within the library but providing dummy data
  // will prevent the app from crashing
  firebaseConfig = {
    apiKey: "dummy data",
    authDomain: "dummy data",
    databaseURL: "dummy data",
    projectId: "dummy data",
    storageBucket: "dummy data",
    messagingSenderId: "dummy data",
    appId: "dummy data",
    measurementId: "dummy data",
  };

}

export { 
  firebaseConfig
};